@for (child of menuItems; track child; let i = $index) {
	<li class="app-submenu-item" routerLinkActive="menu-item-link-active" [routerLinkActiveOptions]="{ exact: false }">
		<a
			[attr.data-testid]="(child.routerLink ? 'sub-' : 'main-') + child.label"
			pRipple
			(click)="itemClick($event, child, i)"
			[attr.href]="child.url && !child.routerLink ? child.url : null"
			[attr.tabindex]="!visible ? '-1' : null"
			[attr.target]="child.target"
			[routerLink]="child.routerLink"
			[pTooltip]="collapsed ? child.label : null"
			tooltipPosition="right"
			class="themed-item app-submenu-link"
			[ngClass]="[isActive(child, i) ? (getColorKey(child) ? 'bg-' + getColorKey(child) + ' text-contrast-' + getColorKey(child) : 'app-submenu-active') : '']">
			<span class="app-submenu-label" [class.hidden]="collapsed">
				<span class="app-submenu-label-text">{{ child.label }}</span>
				@if (child.badge) {
					<p-chip class="sidebar-beta-badge sm" [label]="child.badge" />
				}
			</span>
			<div class="app-submenu-icons">
				@if (child.items) {
					<i
						class="pi pi-chevron-down app-submenu-chevron transition-transform duration-200"
						[class.hidden]="collapsed"
						[ngClass]="{
							'-rotate-180': isMenuLinkFocused(i) || isChildMenuLinkActive(i),
						}"></i>
				}
				<i
					[ngClass]="[child.icon, getColorKey(child) ? (isActive(child, i) ? 'text-contrast-' + getColorKey(child) : 'text-' + getColorKey(child)) : '']"
					class="app-submenu-icon"></i>
			</div>
		</a>
		@if (child.items && (isMenuLinkFocused(i) || isChildMenuLinkActive(i))) {
			<ul
				app-submenu
				[item]="child"
				[visible]="isMenuLinkFocused(i) || isChildMenuLinkActive(i)"
				[reset]="reset"
				[parentActive]="isMenuLinkFocused(i) || isChildMenuLinkActive(i)"
				[collapsed]="collapsed"
				[@children]="isMenuLinkFocused(i) || isChildMenuLinkActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"
				class="app-submenu-child"
				[ngClass]="isActive(child, i) ? 'border-' + getColorKey(child) : ''"></ul>
		}
	</li>
}
